import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=768043b3&"
import script from "./SingleChoice.vue?vue&type=script&lang=js&"
export * from "./SingleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768043b3')) {
      api.createRecord('768043b3', component.options)
    } else {
      api.reload('768043b3', component.options)
    }
    module.hot.accept("./SingleChoice.vue?vue&type=template&id=768043b3&", function () {
      api.rerender('768043b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/SingleChoice.vue"
export default component.exports